import { CommonAction } from '../../../login/redux/types';
import DealTypes, { DealState } from './types';

const dealInitialState: DealState = {
    deals: [],
    loading: false,
    pastDeals: [],
    ongoingDeals: [],
    deal: undefined,
    dataRoomLoading: false,
    dataRoom: [],
    webinarLoading: false,
    webinars: [],
    disclosure: false,
    trackRecordLoading: false,
    cashflowGraph: [],
    cLoading: false,
    termSheetData:'',
    tsLoading:false,
    teaser: [],
    tLoading: false,
};

const DealReducer = (state = dealInitialState, action: CommonAction): DealState => {
    switch (action.type) {
        case DealTypes.GET_DEALS_REQ:
            return {
                ...state,
                loading: true,
                deals: [],
                pastDeals: [],
                ongoingDeals: [],
                disclosure: false,
            };
        case DealTypes.SET_DEALS:
            const { deals, pastDeals, ongoingDeals } = action.payload;
            return {
                ...state,
                loading: false,
                deals: deals,
                pastDeals: pastDeals,
                ongoingDeals: ongoingDeals,
            };
        case DealTypes.GET_DEAL_DETAIL_REQ:
            return {
                ...state,
                loading: true,
                deal: undefined,
                disclosure: false,
            };
        case DealTypes.SET_DEAL_DETAIL:
            return {
                ...state,
                loading: false,
                deal: action.payload,
            };
        case DealTypes.GET_DEAL_DATA_ROOM_REQ:
            return {
                ...state,
                dataRoomLoading: true,
                dataRoom: [],
            };
        case DealTypes.SET_DEAL_DATA_ROOM:
            return {
                ...state,
                dataRoomLoading: false,
                dataRoom: action.payload,
            };
        case DealTypes.GET_DEAL_WEBINAR_REQ:
            return {
                ...state,
                webinarLoading: true,
                webinars: [],
            };
        case DealTypes.SET_DEAL_WEBINAR:
            return {
                ...state,
                webinarLoading: false,
                webinars: action.payload,
            };
        case DealTypes.SET_DISCLOSURE:
            return {
                ...state,
                disclosure: action.payload,
            };
        case DealTypes.FETCH_TRACK_RECORDS:
            return {
                ...state,
                trackRecordLoading: true,
                trackRecords: undefined,
            };
        case DealTypes.SET_TRACK_RECORDS:
            return {
                ...state,
                trackRecordLoading: false,
                trackRecords: action.payload,
            };
        case DealTypes.FETCH_CASHFLOW_SIMULATOR:
            return {
                ...state,
                cLoading: true,
                cashflowGraph: [],
            };
        case DealTypes.SET_CASHFLOW_SIMULATOR:
            return {
                ...state,
                cLoading: false,
                cashflowGraph: action.payload,
            };
        case DealTypes.GET_TERM_SHEET_DATA_REQ:
            return {
                ...state,
                tsLoading: true,
                termSheetData: '',
            };
        case DealTypes.SET_TERM_SHEET_DATA:
            return {
                ...state,
                tsLoading:false,
                termSheetData: action.payload,
            };
        case DealTypes.FETCH_TEASER_DOC:
            return {
                ...state,
                tLoading: true,
                teaser: [],
            };
        case DealTypes.SET_TEASER_DOC:
            return {
                ...state,
                tLoading: false,
                teaser: action.payload,
            };
        default:
            return state;
    }
};

export default DealReducer;
